import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router";
import { useLocation } from "react-router";
import GetLocalStorage from "./GetLocalStorage";

const useAuth = () => {
  const user = JSON.parse(localStorage.getItem("user_profile"));

  if (user !== null) {
    return user;
  }
};

const ProtectedRoutes = () => {
  const isAuth = useAuth();
  const onboardingStatus = GetLocalStorage("onboardingStatus");
  const location = useLocation();

  // Allow access to /account-setup route even if onboarding is not completed
  if (
    isAuth &&
    onboardingStatus !== "COMPLETED" &&
    !location.pathname.startsWith("/account-setup")
  ) {
    return (
      <Navigate to={`/account-setup?onboardingStatus=${onboardingStatus}`} />
    );
  }

  return isAuth ? <Outlet /> : <Navigate to={"/"} />;
};

const LoggedInRoute = () => {
  const isAuth = useAuth();
  return !isAuth ? <Outlet /> : <Navigate to={"/dashboard"} />;
};

export { ProtectedRoutes, LoggedInRoute };
